import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Spinner } from "react-bootstrap";
import Sidebar from "../sidebar/sidebar";
import Header from "../header/header";
import config from "../../../src/config/config.json";
import { apiCall } from "../../_services/apiCall";
import DocumentListingComponent from "./DocumentListingComponent";
import { useFrameworks, useSources, useFinancialYears } from "../../hooks/useApiData";
import "./DocumentManagement.css";

const DocumentManagement = (props) => {

  const frameworks = useFrameworks();
  const sources = useSources();
  const financialYears = useFinancialYears();

  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const [initialLoadDone, setInitialLoadDone] = useState(false);
  const [sidebarExpanded, setSidebarExpanded] = useState(true);


  const handleSidebarToggle = (isOpen) => {
    setSidebarExpanded(isOpen);
  };

  // Fetch documents data without dependency checks initially
  const getDocuments = async () => {
    try {
      const { isSuccess, data } = await apiCall(
        `${config.POSTLOGIN_API_URL_COMPANY}documents`,
        {},
        {},
        "GET"
      );
      if (isSuccess && data?.documents) {
        setDocuments(data?.documents || []);
      } else {
        console.error("Failed to fetch documents:", data);
        setError("Failed to fetch documents. Please try again later.");
      }
    } catch (error) {
      console.error("Error fetching documents:", error);
      setError("An error occurred while fetching documents.");
    }
  };

  // Initial data loading
  useEffect(() => {
    console.log("Initial data loading useEffect running");

    getDocuments();

    setInitialLoadDone(true);
  }, []);

  const onDocumentUpdate = () => {
    console.log('Call Get DOcuments');
    getDocuments();
  }

  const onDocumentDelete = () => {
    getDocuments();
  }

  return (
    <div className="d-flex flex-row mainclass" style={{ height: "100vh", overflow: "auto" }}>
      <div style={{ flex: sidebarExpanded ? "0 0 21%" : "0 0 60px", position: "sticky", top: 0, zIndex: 999 }}>
        <Sidebar dataFromParent={props.location.pathname} onSidebarToggle={setSidebarExpanded} />
      </div>

      <div style={{ flex: "1", transition: "all 0.3s ease" }}>
        <div style={{ position: "sticky", top: 0, zIndex: 999 }}><Header /></div>
        <div className="content-wrapper">
          <div className="page-header">
            <h1>Evidence Library</h1>
            <p>View all uploaded evidences at one place</p>
          </div>
          
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
              <button 
                type="button" 
                className="btn btn-outline-danger ms-3"
                onClick={getDocuments}
              >
                Retry
              </button>
            </div>
          )}

          {!initialLoadDone ? (
            <div className="loading-container">
              <Spinner animation="border" role="status" variant="primary">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <div className="mt-3">Loading document data...</div>
            </div>
          ) : (
            <DocumentListingComponent
              documents={documents}
              sources={sources}
              financialYears={financialYears}
              frameworks={frameworks}
              loading={!initialLoadDone}
              onDocumentUpdate={onDocumentUpdate}
              onDocumentDelete={onDocumentDelete}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentManagement;